module.exports = __webpack_public_path__ + "img/lotd_4.b5125e96.png";